import styles from './PageWrapper.module.scss';

const PageWrapper = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles['page-wrapper']}>{children}</div>;
};

export default PageWrapper;
